<div id="navbar">
  <img id="header-icon" src="assets/img/union-logo.png" (click)="router.navigate(['/start'])" />
  @if (loginStateService.loggedIn()) {
    <div class="fakelink" style="float:right" (click)="logout()">{{stringService.connectionStrings['LOGOUT']}}</div>
  }
</div>
